const filters = {
    money(value, locale, currency) {
        if (!value) return ''
        let prepend = ''
        let digits = 2
        if (currency === 'MXN') {
            prepend = 'Mex'
            digits = 0
        } else if (currency === 'COP') {
            digits = 0
        } else if (currency === 'HUF') {
            digits = 0
        } else if (currency === 'SEK') {
            digits = 0
        } else if (currency === 'ZAR') {
            return 'R' + value
        } else if (currency === 'MYR') {
            return 'RM' + value
        } else if (currency === 'PHP') {
            return '₱' + value
        } else if (currency === 'AUD') {
            prepend = 'A'
        } else if (currency === 'CAD') {
            return 'C' + parseFloat(value).toLocaleString('en-CA', { currency: 'CAD', style: 'currency' })
        } else if (currency === 'SGD') {
            return 'S' + value.toLocaleString('en-CA', { currency: 'CAD', style: 'currency' })
        } else if (currency === 'NZD') {
            return 'NZ' + value.toLocaleString('en-CA', { currency: 'CAD', style: 'currency' })
        } else if (currency === 'NOK' || currency === 'DKK') {
            return new Intl.NumberFormat('sv', {
                style: 'currency',
                currency: 'SEK',
                maximumFractionDigits: 0
            }).format(value)
        }
        var text = "";
        try {
            text = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency,
                maximumFractionDigits: digits,
                currencyDisplay: 'narrowSymbol'
            }).format(value);
        } catch(e) {
            text = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currency,
                maximumFractionDigits: digits,
                currencyDisplay: 'symbol'
            }).format(value);
        }

        return (
            prepend +
            text
        )
    }
}

export default filters
